export default "__VITE_ASSET__LQPRXe7a__"